// you also need to import some css.. this can be done here or in another file
import '@tryg/style-tokens/build/css/index.css'

import { defineCustomElements} from '@tryg/ui-library/dist/loader';

defineCustomElements(window);
